<template>
    <div>
        <vue-apex-charts type="radialBar" height="350" :options="chartOptions" :series="series" />

        <div class="mt-2 text-left">
            <div v-if="status" class="mb-2 text-center">
                <span :class="['badge', 'p-2', `badge-${status.variant}`]" style="font-size: 0.9rem"> Stok Seviyesi: {{ status.text }} </span>
            </div>

            <table class="table table-sm table-bordered">
                <thead>
                    <tr>
                        <th class="text-nowrap">Açıklama</th>
                        <th class="text-nowrap">Miktar [lt]</th>
                        <th class="text-nowrap">Oran %</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-nowrap">Boş Kapasite</td>
                        <td class="text-right text-nowrap">{{ summaryData.emptySpaceStr }}</td>
                        <td class="text-right font-weight-bolder">{{ summaryData.emptySpacePercentageStr }}</td>
                    </tr>
                    <tr>
                        <td>Yakıt Miktarı</td>
                        <td class="text-right text-nowrap">{{ summaryData.quantityStr }}</td>
                        <td class="text-right font-weight-bolder text-nowrap">{{ summaryData.percentageStr }}</td>
                    </tr>
                    <tr>
                        <td class="text-nowrap">Depo Kapasitesi</td>
                        <td class="text-right text-nowrap">{{ summaryData.capacityStr }}</td>
                        <td class="text-right font-weight-bolder text-nowrap">100,0</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    name: "FuelStorageGauge",
    components: {
        VueApexCharts,
    },
    props: {
        summaryData: { type: Object, required: true },
    },
    // filters: {
    //   formatNumber(value) {
    //     if (isNaN(value)) return 0;
    //     return Number(value).toLocaleString('tr-TR');
    //   }
    // },
    computed: {
        status() {
            const { quantity, minStockLevel, criticalStockLevel } = this.summaryData;
            if (minStockLevel === undefined || criticalStockLevel === undefined) {
                return { text: "Normal", variant: "success" };
            }
            if (quantity <= criticalStockLevel) {
                return { text: "Kritik", variant: "danger" };
            }
            if (quantity <= minStockLevel) {
                return { text: "Minimum Seviyede", variant: "warning" };
            }
            return { text: "Normal", variant: "success" };
        },
        series() {
            const { capacity, quantity, minStockLevel, criticalStockLevel } = this.summaryData;
            if (capacity === 0) return [0, 0, 0];

            const currentPercentage = (quantity / capacity) * 100;
            const minPercentage = (minStockLevel / capacity) * 100;
            const criticalPercentage = (criticalStockLevel / capacity) * 100;

            return [parseFloat(currentPercentage.toFixed(1)), parseFloat(minPercentage.toFixed(1)), parseFloat(criticalPercentage.toFixed(1))];
        },
        chartOptions() {
            const statusColors = {
                main: "#06923E",
                warning: "#F59E0B",
                danger: "#EF4444",
            };

            return {
                chart: { type: "radialBar" },
                plotOptions: {
                    radialBar: {
                        hollow: { size: "25%" },
                        track: { background: "#7A7A73", strokeWidth: "85%", margin: 5 },
                        dataLabels: {
                            name: { show: false },
                            value: { show: false },
                            total: {
                                show: true,
                                label: "Doluluk",
                                fontSize: "1.2rem",
                                formatter: () => `${this.series[0]}%`,
                            },
                        },
                    },
                },
                colors: [statusColors.main, statusColors.warning, statusColors.danger],
                labels: ["Mevcut Doluluk", "Min. Seviye", "Kritik Seviye"],
                legend: {
                    show: true,
                    position: "bottom",
                    horizontalAlign: "center",
                    itemMargin: { horizontal: 10 },
                    formatter: (seriesName, opts) => {
                        const value = opts.w.globals.series[opts.seriesIndex];
                        const formattedValue = value.toLocaleString("tr-TR", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                        });
                        return `${seriesName}: ${formattedValue}%`;
                    },
                },
            };
        },
    },
};
</script>
